<div class="d-md-flex pb-2 mb-md-0">
    <div class="flex-grow-1">
        <div class="back-and-title">
            <abi-back-button></abi-back-button>
            <h4>{{ dateString() }} - {{ groupings[grouping] || grouping }}</h4>
        </div>
    </div>
    <div class="ml-2">
        <button [matMenuTriggerFor]="actionMenu" class="btn btn-outline-primary dropdown-toggle">{{ 'System.Actions' | translate }}</button>
        <mat-menu #actionMenu="matMenu" class="py-0">
            <mat-action-list>
                <abi-export-buttons [table]="table" [totalResults]="totalResults" [rowsObservable]="allData()"></abi-export-buttons>
            </mat-action-list>
        </mat-menu>
    </div>
</div>

<div class="table-responsive">
    <table abi-table #table [columns]="columns" [rows]="dataList?.items" class="table-hover table-striped table-sm"
        defaultSort="jobId" [remoteData]="remoteData" [hiddenColumns]="true"
        [colsObs]="colsObs">
        <ng-template th="contact.mobile" let-column>
            <span *ngIf="(isMobile|async) === false">{{ column.realHeader }}</span>
        </ng-template>
        <ng-template td="contact" let-row="row" let-value="value">
            <a [routerLink]="['..', row.jobId]">{{ value }}</a>
        </ng-template>
        <ng-template td="jobId" let-row="row" let-value="value">
            <a [routerLink]="['..', row.jobId]">{{ row | job:'cleanJobId' }}</a>
        </ng-template>
        <ng-template td="resourceId" let-value="value">
            <a href="." (click)="showResource(value)">{{ value }}</a>
        </ng-template>
        <ng-template td="address" let-row="row" let-value="value">
            <a [ngClass]="['address', addressClass(row.address)]" [map]="row.address">{{ value }}</a>
        </ng-template>
        <ng-template td="contact.mobile" let-value="value">
            <span *ngIf="isMobile|async; else desktop">
                <a class="btn btn-sm btn-outline-secondary text-success" [href]="'tel:' + value">
                    <i class="fas fa-fw fa-phone"></i>
                </a>
            </span>
            <ng-template #desktop>
                <span [abiTelephone]="value"></span>
            </ng-template>
        </ng-template>
        <ng-template td="" let-row="row">
            <button *ngIf="userCanEdit" class="btn btn-primary btn-sm" [attr.title]="'Job.Schedule' | translate" (click)="schedule(row)">
                <i class="far fa-calendar-check"></i>
            </button>
        </ng-template>
    </table>
</div>

<abi-pager [pageNumber]="paged?.pageNumber || 1" [totalResults]="totalResults" [pagedO]="pagedS"></abi-pager>
